import { Link } from "react-router-dom";
import { SignUp } from "@clerk/clerk-react";
import { ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";
import { clerkAppearance } from "@/lib/clerkAppearance";

export default function Register() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left brand */}
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-40" />
        <Link to="/" className="flex items-center gap-2 relative z-10">
          <Logo to={null} dark iconSize={36} />
        </Link>
        <div className="relative z-10">
          <h2 className="font-display text-4xl font-extrabold leading-tight">
            Mulai gratis. <span className="text-sky-400">50 leads</span> tiap bulan, tanpa kartu kredit.
          </h2>
          <ul className="mt-6 space-y-3 text-slate-300">
            {["Scrape Google Maps real-time", "Connect WA sendiri via QR", "Blast & kelola pipeline lead"].map((t) => (
              <li key={t} className="flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-sky-400" /> {t}
              </li>
            ))}
          </ul>
        </div>
        <p className="text-slate-500 text-sm relative z-10">© 2026 RESADA</p>
      </div>

      {/* Right: Clerk Sign Up */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm animate-float-up" data-testid="clerk-signup">
          <div className="lg:hidden mb-8">
            <Logo to="/" iconSize={34} />
          </div>
          <SignUp
            routing="hash"
            signInUrl="/login"
            forceRedirectUrl="/app"
            fallbackRedirectUrl="/app"
            appearance={clerkAppearance}
          />
        </div>
      </div>
    </div>
  );
}
